import { Box } from "@mui/material";
import { useGetIdentity, useTranslate } from "react-admin";

import { ResourceName } from "../constants/resources";
import { LocationTypeEnum, UserType } from "../generated/graphql";
import { useLocationFilterContext } from "../hooks/useLocationFilterContext";
import { useOrganizationContext } from "../hooks/useOrganizationContext";
import { Count } from "./Count";
import { CustomMenuItem } from "./CustomMenuItem";
import { Icon } from "./icons";

type MenuItem = {
  resource: ResourceName;
  to: string;
  icon: React.ReactElement;
};

export const MenuItemWithCount = ({ resource, to, icon }: MenuItem) => {
  const { organizationId: selectedOrganizationId } = useOrganizationContext();
  const { locationId: selectedLocationId } = useLocationFilterContext();
  const { data: identity } = useGetIdentity();
  const translate = useTranslate();

  const filter =
    resource === ResourceName.Organization
      ? {}
      : selectedOrganizationId
        ? {
            organizationId: selectedOrganizationId,
            ...(selectedLocationId && { locationId: selectedLocationId }),
            ...(resource === ResourceName.Location && {
              type: selectedLocationId ? undefined : [LocationTypeEnum.Site],
              partOfId: selectedLocationId,
            }),
          }
        : {};

  const isAllStandorte = resource === ResourceName.Location && !selectedLocationId;
  const translatedName = isAllStandorte
    ? translate("resources.LocationSites", { _: "Standorte" })
    : translate(`resources.${resource}`);
  const resolvedIcon = isAllStandorte ? <Icon type="home" size="large" /> : icon;

  if (identity?.kind === UserType.CustomerService) {
    return <CustomMenuItem to={to} primaryText={translatedName} leftIcon={resolvedIcon} />;
  }

  return (
    <CustomMenuItem
      to={to}
      primaryText={
        <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <span>
            {translatedName}
            <Count resource={resource} filter={filter} timeout={500} sx={{ fontSize: "inherit", color: "inherit" }} />
          </span>
        </Box>
      }
      leftIcon={resolvedIcon}
    />
  );
};
